import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export const SubscriptionPaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center"
      style={{
        background:
          "radial-gradient(ellipse at center, #dde0ff 0%, #eef1ff 60%, #f4f5ff 100%)",
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.88, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.45, ease: "easeOut" }}
        className="relative bg-white rounded-3xl shadow-2xl p-10 max-w-sm w-full text-center overflow-hidden"
      >
        {/* Checkmark circle */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            delay: 0.2,
            type: "spring",
            stiffness: 260,
            damping: 18,
          }}
          className="mx-auto mb-6 w-20 h-20 rounded-full bg-[#48bb60] flex items-center justify-center relative z-10"
          style={{ boxShadow: "0 8px 32px rgba(72,187,96,0.45)" }}
        >
          <svg
            className="w-10 h-10 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth={3}
            viewBox="0 0 24 24"
          >
            <motion.path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ delay: 0.35, duration: 0.45, ease: "easeOut" }}
            />
          </svg>
        </motion.div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-900 mb-2 relative z-10">
          Payment Successful 🎉
        </h2>

        {/* Description */}
        <p className="text-gray-500 text-sm leading-relaxed mb-8 relative z-10">
          Your payment has been successfully processed. Now you can go to the
          homepage &amp; discover new features.
        </p>

        {/* Button */}
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={() => navigate("/")}
          className="w-full py-3 rounded-xl bg-[#5563F6] hover:bg-[#4450D6] text-white font-medium text-sm transition relative z-10"
          style={{ boxShadow: "0 4px 20px rgba(85,99,246,0.35)" }}
        >
          Continue
        </motion.button>
      </motion.div>
    </div>
  );
};
